import type { HelpFile } from '../../types/help'
import { AccessProfilesTestIds } from '../../../testids/AccessProfilesTestIds'

export const accessProfilesHelp: HelpFile = {
  docPage: '/docs/access/entitlements',
  texts: {
    [AccessProfilesTestIds.accessProfilesList]:
      'Every access profile — a named bundle of enforcement objects that can be requested or auto-assigned.',
    [AccessProfilesTestIds.btnCreateProfile]: null,
    [AccessProfilesTestIds.colAutoAssignable]:
      'Whether an auto-assign rule may grant this profile without a request.',
    [AccessProfilesTestIds.colRequestable]:
      'Whether parties may request this profile through the access-request flow.',
  },
}
